import React from "react";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="p-4">
      <button
        onClick={() => {
          navigate(-1);
        }}
        className="my-5 bg-green-500 rounded-xl shadow-xl p-2"
      >
        <IoArrowBack className="text-white text-2xl"></IoArrowBack>
      </button>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>
          Novelio Technologies Private Limited (Northstarz.Ai) Privacy Policy
        </strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Welcome to Northstarz.Ai, a product of Novelio Technologies Private
        Limited (&quot;Northstarz.Ai,&quot; &quot;we,&quot; &quot;our,&quot; or
        &quot;us&quot;). Protecting your privacy is important to us, and this
        Privacy Policy explains how we collect, use, and disclose information
        from users of our website and related services (collectively, the
        &quot;Services&quot;). By using our Services, you agree to the practices
        described in this Privacy Policy.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Information We Collect</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <u>Information You Provide to Us</u>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        We collect the following information when you interact with
        Northstarz.Ai:
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Registration Information: Your name, work email address, contact phone
        number, and organization details.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;&nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Communications: Information you provide when contacting us directly,
        such as your name, email address, phone number, and message contents. By
        providing this information, you consent to receive newsletters,
        marketing campaigns, and be part of our mailing lists.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Job Applications: When you apply for a job on Northstarz.Ai, we
        collect relevant information from your resume. This may include
        identifiers, characteristics of protected classifications, professional
        or employment-related information, education information, inferences,
        feedback, publicly available information, financial data, and health
        data.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <span style={{ color: "blue" }}>-&nbsp;</span>Chat Windows: Information
        entered into chat windows, and data processed using third-party APIs for
        automation services.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <u>Other Information We Collect When You Use Our Services</u>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Location Information: Inferred general location information and
        precise location information with your permission.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Device Information: Details about the device and software you use to
        access our Services.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Usage Information: Information about your interactions with our
        Services to improve user experience.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Information from Cookies and Similar Technologies: We use cookies and
        similar technologies to collect information about your online
        activities.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>
          <u>Information We Receive from Third Parties</u>
        </strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Information from Third-Party Services: If you link our Services to
        third-party services, we may receive information about you as outlined
        in this Privacy Policy.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Talent Search
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Northstarz.Ai processes and stores searchable resume data for the
        purpose of facilitating employers in inviting candidates to apply for
        job openings. Candidates have control over the visibility of their
        resumes, with options to configure privacy settings.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>How We Use the Information We Collect</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        We use your information for various purposes, including:
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Managing the recruitment system and job applications.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Assessing skills, qualifications, and interests.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Communicating with you about job opportunities.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Verifying information through reference and background checks.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Sending information about the new hire and employee experience.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Improving our recruitment system and activities.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Detecting and preventing fraud or illegal activities.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Complying with legal obligations.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Automated Decisions About You</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        We may use automated decision-making processes for recruitment purposes,
        subject to legal requirements and your consent.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        How We Disclose the Information We Collect
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        We may disclose information to:
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Vendors and Service Providers.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Users and Public Information.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Social Networks and Other Online Services.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Marketing Communications.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Analytics Partners.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - As Required By Law and Similar Disclosures.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Merger, Sale, or Other Asset Transfers.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - With Your Consent.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Your Choices
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Adjusting Sharing Preferences.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Managing Public Information.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Controlling Location Information.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Disabling Third-Party Integrations.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Managing Marketing Communications.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        - Do Not Track: We do not respond to Do Not Track signals.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Third Parties</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Our Services may contain links to third-party websites. This Privacy
        Policy does not apply to third-party services, so please review their
        privacy policies.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Log Data</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        When you use our Service through a mobile device, certain information is
        automatically collected, including, but not limited to, the type of
        mobile device, unique device ID, IP address, mobile operating system,
        the type of mobile Internet browser, and other statistics (&quot;Log
        Data&quot;).
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Furthermore, we may utilize third-party services like Google Analytics
        to collect, monitor, and analyze this information, enhancing the
        functionality of our Service. These third-party service providers have
        their own privacy policies detailing how they handle such information.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Please refer to the section on Location Information below for details on
        the use of your location information and the available options.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Location Information</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Depending on the permissions you&apos;ve set on your device, we may use
        and store location information. This data helps us provide features,
        enhance, and customize our Service. You can enable or disable location
        services at any time through your mobile device settings. Enabling
        location services ensures accurate location information for nearby
        points of interest, directions, and more. It&apos;s important to note
        that other users will never have access to your specific location, even
        if you share a spot. In such cases, the information will only be
        presented as another point of interest on the map.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Cookies</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Cookies are small data files, including an anonymous unique identifier,
        sent to your browser from a website and stored on your device. We use
        cookies to collect information to improve our services.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        You can configure your browser to reject all cookies or notify you when
        receiving a new cookie. Most browsers provide information on managing
        cookies. However, if you choose not to accept cookies, some features of
        our Service may be unavailable. We recommend keeping cookies turned on
        for optimal service use.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Children&rsquo;s Privacy</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Our Services are not intended for children under 13, and we do not
        knowingly collect personal information from them.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Service Providers</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        We may employ third party companies and individuals to facilitate our
        Service, to provide the Service on our behalf, to perform
        Service-related services and/or to assist us in analyzing how our
        Service is used.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        These third parties have access to your Personal Information only to
        perform specific tasks on our behalf and are obligated not to disclose
        or use your information for any other purpose.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>&nbsp;</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Communications</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>&nbsp;</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        We may use your Personal Information to contact you with newsletters,
        marketing or promotional materials and other information that may be of
        interest to you. You may opt out of receiving any, or all, of these
        communications from us by following the unsubscribe link or instructions
        provided in any email we send or by contacting us.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Compliance With Laws</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        We will disclose your Personal Information where required to do so by
        law or subpoena or if we believe that such action is necessary to comply
        with the law and the reasonable requests of law enforcement or to
        protect the security or integrity of our Service.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Business Transaction</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        If Northstarz.Ai is involved in a merger, acquisition or asset sale,
        your Personal Information may be transferred as a business asset. In
        such cases, we will provide notice before your Personal Information is
        transferred and/or becomes subject to a different Privacy Policy.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Security</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        The security of your Personal Information is important to us, and we
        strive to implement and maintain reasonable, commercially acceptable
        security procedures and practices appropriate to the nature of the
        information we store, in order to protect it from unauthorized access,
        destruction, use, modification, or disclosure.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        However, please be aware that no method of transmission over the
        internet, or method of electronic storage is 100% secure and we are
        unable to guarantee the absolute security of the Personal Information we
        have collected from you.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>International Transfer</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Your information, including Personal Information, may be transferred to
        - and maintained on - computers located outside of your state, province,
        country or other governmental jurisdiction where the data protection
        laws may differ than those from your jurisdiction.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        If you are located outside India and choose to provide information to
        us, please note that we transfer the information, including Personal
        Information, to India and process it there.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Your consent to this Privacy Policy followed by your submission of such
        information represents your agreement to that transfer.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Update Your Information
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        You can update your account and profile information or close your
        account by sending us an email to support@northstarz.ai
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Changes to this Privacy Policy</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        We will post any changes to this Privacy Policy on this page, and the
        revised version will be effective when posted. We will notify you of
        material changes through our Services or other communication channels.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        <strong>Contact Information</strong>
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        If you have questions, comments, or concerns about our processing
        activities, please email us at info@interviewguru.co.
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        Last Updated: January 12, 2024
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          fontSize: "13px",
          fontFamily: "Calibri,sans-serif",
          textAlign: "justify",
        }}
      >
        &copy; 2023-2030 ALL RIGHTS RESERVED
      </p>
    </div>
  );
};

export default Privacy;
